// register component with react habitat
//
// Registered synchronously (not via codeSplit/async) because the calculator
// is the primary content of whatever page it's mounted on — there is no
// benefit to lazy-loading it, and it avoids the "@wordpress/i18n strings
// inside split chunks" caveat entirely (see src/scripts/init/localization.js).
import Component from './index';

export default {
	RoiCalculator: Component,
};
